<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-parentStarLicense__travelposition">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('parentStarLicense:travelPosition:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('parentStarLicense:travelPosition:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="positionName" label="站点名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="weight" label="权重" header-align="center" align="center"></el-table-column>
        <el-table-column prop="longitude" label="经度" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dimension" label="维度" header-align="center" align="center"></el-table-column>
        <el-table-column prop="imgSrc" label="图片地址" header-align="center" align="center">
          <template slot-scope="scope">
            <el-image style="height:100px;width: 100px;" :src="scope.row.imgSrc" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="introduction" label="站点简介" header-align="center" align="center"></el-table-column>
        <el-table-column prop="chargePerson" label="负责人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="chargePersonPhone" label="负责人电话" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="province" label="省" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="city" label="市" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="area" label="县区" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="address" label="详细地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="openTime" label="开馆时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="closeTime" label="闭馆馆时间" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>-->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('parentStarLicense:travelPosition:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('parentStarLicense:travelPosition:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './travelposition-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/parentStarLicense/travelPosition/page',
        getDataListIsPage: true,
        exportURL: '/parentStarLicense/travelPosition/export',
        deleteURL: '/parentStarLicense/travelPosition',
        deleteIsBatch: true
      },
      dataForm: {
      }
    }
  },
  watch: {
  },
  components: {
    AddOrUpdate
  }
}
</script>
